export const Auth = {
  clientId: 'nvjr1n2h2vryq378.igeo.ro',
  clientName: 'WebUI',
  clientPassword: 'oQsytu0a2dKNtG38BDHE',
  pathFetchAccessToken: 'auth/token'
};

export const AuthenticateModes = {
  SIGN_IN: 1,
  SIGN_UP: 2
};

export const SignUpModes = {
  LOCAL: 1
};

export const ShowToastMessageForSeconds = 5;

export const ImageLocateStates = {
  VIEW_IMAGE: 1,
  VIEW_MAP: 2,
  VIEW_QA: 3
};

export const PointDefaultLocation = {
  lat: 1.1,
  lng: 1.1
};

export const TimerQA = 45;

export const QuestionTypes = {
  COUNTRY_FLAG: 1,
  COUNTRY_CAPITAL: 2,
  RIVER: 3,
  COUNTRY_AREA: 4,
  CITY_COORDINATES: 5,
  COUNTRY_HIGHEST_POINT: 6,
  COUNTRY_OUTLINE: 7,
  CITY_UTC: 8,
  COUNTRY_NEIGHBOR: 9,
  LAKE_SHORES: 10,
  COUNTRY_POPULATION: 11
};

export const TemperatureSetpointValues = [
  18,
  18.5,
  19,
  19.5,
  20,
  20.25,
  20.5,
  20.75,
  21,
  21.25,
  21.5,
  21.75,
  22,
  22.25,
  22.5,
  22.75,
  23,
  23.25,
  23.5,
  23.75,
  24,
  24.25,
  24.5,
  24.75,
  25
];